/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';

export const columns = (): [] => [
  {
    selector: 'coupon_code',
    name: 'Code',
    sortable: false,
    maxWidth: '200px',
    grow: 2
  },
  {
    selector: 'url',
    name: 'URL',
    sortable: false,
    grow: 3,
    cell: (row: {}): string => {
      return (
        <a
          href={`${process.env.EVENT_HOST}${row.url}`}
          rel="noopener noreferrer"
          target='_blank'
        >
          {process.env.EVENT_HOST}{row.url}
        </a>
      );
    }
  }
];
